import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { SCENES } from "@/lib/images";

export default function AdminLogin() {
  const { authed, login } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (authed) navigate("/admin"); }, [authed, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Invalid password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative grid min-h-[100dvh] place-items-center px-5">
      <div className="absolute inset-0">
        <img src={SCENES.mistyPeak} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/80" />
      </div>
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-2xl border border-border bg-cream p-8 shadow-2xl">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-terracotta text-cream">
          <Lock className="h-5 w-5" />
        </div>
        <h1 className="mt-5 text-center font-serif text-2xl font-bold text-forest">Admin Access</h1>
        <p className="mt-1 text-center text-sm text-forest/60">Manage tributes & donations</p>

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          data-testid="admin-password-input"
          className="mt-6 w-full rounded-xl border border-input bg-background px-4 py-3 text-forest outline-none focus:border-terracotta focus:ring-2 focus:ring-terracotta/20"
        />
        {error && <p className="mt-3 text-sm text-destructive" data-testid="admin-login-error">{error}</p>}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-button"
          className="mt-5 w-full rounded-full bg-terracotta py-3 font-medium text-cream transition hover:bg-terracotta-dark disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
